import type * as React from 'react';

export interface WundoChatIconProps extends React.ComponentProps<'svg'> {
  size?: number;
}

/**
 * The mark for talking to Wundo — the design prototypes' own glyph, drawn
 * wherever the chat is entered, so the strip and the topbar say the same thing.
 * Not a lucide icon: a generic speech bubble says "chat with anyone".
 */
export function WundoChatIcon({ size = 20, ...props }: WundoChatIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
      {...props}
    >
      <path d='M12 3v4M12 3 9.5 5.5M12 3l2.5 2.5' />
      <path d='M5 12a7 7 0 0 0 14 0' />
    </svg>
  );
}
